import { useState } from 'react';
import { useMutation, useQuery } from 'react-apollo';
import produce from 'immer';

import {
  MeForPrintPartners,
  MeWithPrintAssets,
} from '../../../../../../../../graphql/queries/account';
import { printAssetDelete as printAssetDeleteMutation } from '../../../../../../../../graphql/mutations/print-assets';

const useAccountPrintAssets = ({ printAssetType }) => {
  const [selectedPricingCategoryIds, setSelectedPricingCategoryIds] = useState(
    [],
  );
  const [searchQuery, setSearchQuery] = useState('');

  const { data: { me: meForPrintPartners } = {} } = useQuery(
    MeForPrintPartners,
    {
      fetchPolicy: 'cache-and-network',
    },
  );

  const {
    data: { me: meWithPrintAssets } = {},
    loading: loadingPrintBackgrounds,
  } = useQuery(MeWithPrintAssets, {
    variables: {
      search_query: searchQuery,
      pricing_category_ids: selectedPricingCategoryIds,
      print_asset_type: printAssetType,
    },
    fetchPolicy: 'cache-and-network',
  });

  const [printAssetDelete] = useMutation(printAssetDeleteMutation);

  const onPrintAssetDelete = async id => {
    const result = await printAssetDelete({
      variables: {
        input: {
          print_asset_id: id,
        },
      },
      update: store => {
        const data = store.readQuery({
          query: MeWithPrintAssets,
          variables: {
            search_query: searchQuery,
            pricing_category_ids: selectedPricingCategoryIds,
            print_asset_type: printAssetType,
          },
        });

        const updatedData = produce(data, draft => {
          draft.me.print_assets.total -= 1;
          draft.me.print_assets.records = data.me.print_assets.records.filter(
            printBackground => printBackground.id !== id,
          );
        });

        store.writeQuery({
          query: MeWithPrintAssets,
          variables: {
            search_query: searchQuery,
            pricing_category_ids: selectedPricingCategoryIds,
            print_asset_type: printAssetType,
          },
          data: updatedData,
        });
      },
    });

    return result;
  };

  return {
    loadingPrintBackgrounds,
    user: meForPrintPartners,
    userId: meForPrintPartners?.id,
    printPartnerId: meForPrintPartners?.pro_settings?.default_print_partner?.id,
    printAssets: meWithPrintAssets?.print_assets?.records ?? [],
    printAssetsTotal: meWithPrintAssets?.print_assets_total?.total ?? 0,
    onPrintAssetDelete,
    searchQuery,
    setSearchQuery,
    selectedPricingCategoryIds,
    setSelectedPricingCategoryIds,
  };
};

export default useAccountPrintAssets;
